import React from "react";
import "../../SecuritySchoolsComponents/TabCard.css";
import Link from '@mui/material/Link';

function PlatformSecurity() {
  return (
    <>
    <div className="tabCard-content">
    <div className="SSA-row flexCenter">
        <div className="SSA-box">
            <Link to={'/SAPSecurity'} className="calendar-link">
                <img src="images/SecuritySchools/SecurityPlatforms/SAP.png" alt="SSA-img" className="SSA-img" />
                <div className="SSA-box-content">
                    <h3>SAP​</h3>
                    <p>SAP GRC Training</p>
                    <a href="/SAPSecurity">Learn more</a>
                </div>
            </Link>
        </div>
        <div className="SSA-box">
            <Link to={'/SecurityPlatforms'} className="calendar-link">
                <img src="images/SecuritySchools/SecurityPlatforms/SalesforceSecurity.png" alt="SSA-img" className="SSA-img" />
                <div className="SSA-box-content">
                    <h3>Salesforce Security​</h3>
                    <p>Salesforce training trains security resources in Salesforce Security, Ongoing monitoring skills and Now/Workday Security.</p>
                    <a href="/SecurityPlatforms">Learn more</a>
                </div>
            </Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default PlatformSecurity;
